import { Configuration, LogLevel } from "@azure/msal-browser";

const clientId = process.env.REACT_APP_AAD_APP_CLIENT_ID || '';
const authority = process.env.REACT_APP_AUTHORITY || '';
const loginScopes = process.env.REACT_APP_LOGIN_SCOPES?.split(' ') || [];
const apiScopes = process.env.REACT_APP_API_SCOPES?.split(' ') || [];
const appUrl = process.env.REACT_APP_URL || '';

const isLocalEnvironment = () => process.env.REACT_APP_ENV === 'local' ? true : false;
const loggingLevel = isLocalEnvironment() ? LogLevel.Verbose : LogLevel.Error
export const msalConfig: Configuration = {
    auth: {
        clientId,
        authority,
        postLogoutRedirectUri: appUrl,
        redirectUri: appUrl,
        knownAuthorities: [authority],
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            piiLoggingEnabled: false,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return true;
                }
                if (level <= loggingLevel) {
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                    }
                }
            }
        }
    }
};
// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: [...loginScopes, ...apiScopes],
    authority,
    forceRefresh: true, // Set this to "true" to skip a cached token and go to the server to get a new token
    loginHint: 'email',
    extraQueryParameters: { domain_hint: 'organizations' },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const apiRequest = {
    scopes: apiScopes,
    forceRefresh: false,
};